import React, { useState } from 'react';
import { Save, Plus, Trash2 } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const VisitInfoManager = ({ onMessage }) => {
  const [info, setInfo, refetch] = useAdminData('visit-info', { heading: 'Good to Know', items: [] });
  const [saving, setSaving] = useState(false);

  const items = info.items || [];
  const setItems = (next) => setInfo({ ...info, items: next });

  const addItem = () => setItems([...items, { label: '', value: '' }]);
  const updateItem = (idx, key, val) => {
    const next = [...items];
    next[idx] = { ...next[idx], [key]: val };
    setItems(next);
  };
  const removeItem = (idx) => setItems(items.filter((_, i) => i !== idx));

  const save = async () => {
    setSaving(true);
    try {
      await apiCall('PUT', 'visit-info', { heading: info.heading, items });
      onMessage('success', 'Saved');
      refetch();
    } catch (e) { onMessage('error', e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold mb-2">Visit Us — Good to Know</h2>
      <p className="text-sm text-gray-500 mb-6">Practical info shown at the bottom of the Contact section on the homepage (dress code, parking, etc).</p>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Section Heading</label>
          <input type="text" value={info.heading || ''} onChange={(e) => setInfo({ ...info, heading: e.target.value })} className="w-full border rounded-lg px-4 py-2" data-testid="visit-info-heading-input" />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Info Items</label>
          {items.map((it, idx) => (
            <div key={idx} className="grid grid-cols-12 gap-3 mb-3" data-testid={`visit-info-item-${idx}`}>
              <input type="text" placeholder="Label (e.g. Parking)" value={it.label} onChange={(e) => updateItem(idx, 'label', e.target.value)} className="col-span-3 border rounded-lg px-3 py-2" />
              <input type="text" placeholder="Value" value={it.value} onChange={(e) => updateItem(idx, 'value', e.target.value)} className="col-span-8 border rounded-lg px-3 py-2" />
              <button onClick={() => removeItem(idx)} className="text-red-600 hover:bg-red-50 rounded col-span-1 flex items-center justify-center" data-testid={`delete-visit-item-${idx}`}><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={addItem} className="text-sm text-[#C9A86C] hover:underline flex items-center gap-1 mt-2" data-testid="add-visit-item-btn"><Plus size={14} /> Add Item</button>
        </div>
      </div>

      <button onClick={save} disabled={saving} className="mt-6 bg-[#C9A86C] text-white px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50" data-testid="visit-info-save-btn">
        <Save size={18} /> {saving ? 'Saving…' : 'Save Changes'}
      </button>
    </div>
  );
};

export default VisitInfoManager;
